import { Controller } from "@hotwired/stimulus"
import { post } from '../../helpers/request_helpers'

export default class extends Controller {
  static classes = ['buttons']

  static values = { url: String, userSignedIn: Boolean }

  async hide() {
    if (!this.userSignedInValue) {
      this.dispatch('login-required')
      return
    }

    document.querySelectorAll(`.${ this.buttonsClass }`).forEach(v => v.disabled = true)

    try {
      await post(this.urlValue)
    } catch {
      document.querySelectorAll(`.${ this.buttonsClass }`).forEach(v => v.disabled = false)
      return
    }

    this.dispatch('hide')
  }
}
